import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import './style.css';
import { ImgPopup } from '@/components/Exporter';
import { Icon } from '@iconify/react/dist/iconify.js';


// @Ahmed Tamer
//  exported it for reuse in AC patient medical files
//  maybe move it in utils !!

export const getFileIcon = (name) => {
        let type = name.split('.')[1].toLowerCase();
        if(type === 'pdf') return <Icon icon="fluent:document-pdf-16-filled" color="#ef4444" width={20} height={20} />;
        if(type === 'excel') return <Icon icon="mdi:file-excel-box" color="#059669" width={20} height={20} />;
        if(type === 'doc' || type === 'docx') return <Icon icon="mdi:file-word-box" color="#2563eb" width={20} height={20} />;
        if( ["png" , "jpg" , "jpeg"].includes(type)) return <Icon icon="tabler:photo-filled" color="#f59e0b" width={20} height={20} />;
        return <Icon icon="akar-icons:file" color="#6b7280" width={20} height={20} />;
    };

const PatientDocuments = ({ data }) => {
    const { t } = useTranslation();
    const [viewingDocument, setViewingDocument] = useState("tst");
    const [activeCategory, setActiveCategory] = useState('medicalReports');
    const imgRef = useRef(null);

    const handleViewDocument = (doc) => {
        if (doc.includes("pdf")) {
            window.open(`${window.API_URL}${doc}`, "_blank");
            return;
        }
        setViewingDocument(`${window.API_URL}${doc}`);
        imgRef.current.click()
    };

    const OrganizedFiles = useMemo(() => {
        return {
            medicalReports: data?.files?.filter(file => ["Medical Reports", "medicalReports"].includes(file.name))?.flatMap(file => file.data),
            labResults: data?.files?.filter(file => ["labReports", "Lab Results Reports"].includes(file.name))?.flatMap(file => file.data),
            xrayCT: data?.files?.filter(file => ["X-ray/CT Image Reports", "xrayReports"].includes(file.name))?.flatMap(file => file.data),
        };
    }, [data]);

 



    return (
        <div className="patient-documents-section">
            <div className="patient-documents-header">
                <div className="patient-documents-icon">
                    <Icon icon="codex:file" width={30} height={30} />
                </div>
                <h3 className="patient-documents-title">{t('patient-documents-files')}</h3>
            </div>

            <div className="patient-documents-categories">
                <div onClick={() => setActiveCategory('medicalReports')} className={`patient-documents-category-badge ${activeCategory === 'medicalReports' ? 'patient-documents-category-badge-active' : ''}`}>
                    {t('medical-reports')}
                    <span className="patient-documents-category-count">{OrganizedFiles?.medicalReports?.length || 0}</span>
                </div>
                <div onClick={() => setActiveCategory('labResults')} className={`patient-documents-category-badge ${activeCategory === 'labResults' ? 'patient-documents-category-badge-active' : ''}`}>
                    {t('lab-results')}
                    <span className="patient-documents-category-count">{OrganizedFiles?.labResults?.length || 0}</span>
                </div>
                <div onClick={() => setActiveCategory('xrayCT')} className={`patient-documents-category-badge ${activeCategory === 'xrayCT' ? 'patient-documents-category-badge-active' : ''}`}>
                    {t('xray-ct-images')}
                    <span className="patient-documents-category-count">{OrganizedFiles?.xrayCT?.length || 0}</span>
                </div>
            </div>

            <div className="patient-documents-list">
                {/* Medical Reports */}
                {OrganizedFiles?.[activeCategory]?.map((doc) => (
                    <div key={doc.id} className="patient-documents-item">
                        <div className="patient-documents-item-left">
                            <div className="patient-documents-item-icon">
                                {getFileIcon(doc?.name)}
                            </div>
                            <div className="patient-documents-item-date">
                                <span className="patient-documents-item-name">{doc?.name?.split("/")?.[1]?.substring(0, 30)}</span>
                                <span className="patient-documents-item-size">{doc?.date?.split("T")?.[0]}</span>
                            </div>
                        </div>
                        <div className="patient-documents-item-actions">
                            <button
                                className="patient-documents-item-action-btn"
                                onClick={() => handleViewDocument(doc?.name)}
                                aria-label="View document"
                            >
                                <Icon icon="iconoir:eye-solid" width={25} height={25} />
                            </button>
                        </div>
                    </div>
                ))}


                <ImgPopup isHideText link={viewingDocument} refImg={imgRef} />
            </div>
        </div>
    );
};

export default PatientDocuments;

